export const formTypes = {
  text: 'text',
  textArea: 'textArea',
  password: 'password',
  number: 'number',
  money: 'money',
  percent: 'percent',
  select: 'select',
  selectComplete: 'selectComplete',
  selectCreate: 'selectCreate',
  switch: 'switch',
  date: 'date',
  phone: 'phone',
  radio: 'radio',
  checkbox: 'checkbox',
  identification: 'identification'
};
